"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-medal.tsx
var Medal = function Medal(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M22.6668 13.9067V2.66666H9.3335V13.9067C9.3335 14.3733 9.5735 14.8133 9.98683 15.0533L15.5602 18.4L14.2402 21.52L9.6935 21.9067L13.1468 24.8933L12.0935 29.3333L16.0002 26.9733L19.9068 29.3333L18.8668 24.8933L22.3202 21.9067L17.7735 21.52L16.4535 18.4L22.0268 15.0533C22.4268 14.8133 22.6668 14.3867 22.6668 13.9067ZM17.3335 16.3067L16.0002 17.1067L14.6668 16.3067V3.99999H17.3335V16.3067Z",
    fill: "currentColor"
  }));
};

var _default = Medal;
exports.default = _default;